import React, { useState } from 'react';
import Image from 'next/image';
import dynamic from 'next/dynamic';
import {
    Card,
    CardContent,
    CardHeader,
    CardActions,
    Button,
    Box,
    Chip,
    Avatar,
    Collapse,
    IconButton,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { MonetizationOn, Close } from '@material-ui/icons';
import PropTypes from 'prop-types';
import styles from 'styles/components/specsSoeezauto.module.scss';
import ModelSpecs from 'components/modelSpecs';
import Link from 'components/link';
import NotifierDialog from 'components/notifierDialog';
import { numberFrance } from 'tools/functions';

const SpecsSoeezautoTrims = dynamic(() => import('./specsSoeezautoTrims'), {
    ssr: false,
});

const FicheTechnique = (props) => {
    const { model } = props;
    // const classes = useStyles();
    const [currentVersion, setCurrentVersion] = useState(model.versions[0]);
    const [selectedVersionIndex, setSelectedVersionIndex] = useState(0);
    const [alertOpen, setAlertOpen] = useState(true);
    const [notification, setNotification] = useState({
        status: '',
        title: '',
        message: '',
        errors: {},
    });

    // useEffect(() => {
    //     if (baseModel) {
    //         props.actionGetModel(baseModel.id);
    //     }
    // }, []);

    // useEffect(() => {
    //     if (dataGetModel) {
    //         setModel(dataGetModel);
    //         props.actionSetGetModelToNull();
    //         props.actionGetModelTrims(baseModel.id);
    //     }
    //     if (errorGetModel) {
    //         setNotification({
    //             status: 'ok_and_dismiss',
    //             title: 'Il a eu une erreur',
    //             message: 'Merci de ressayer',
    //             errors: {},
    //         });
    //         props.actionSetGetModelToNull();
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [dataGetModel, errorGetModel, baseModel]);

    // useEffect(() => {
    //     if (baseModel) {
    //         props.actionGetModelTrims(baseModel.id);
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    // useEffect(() => {
    //     if (dataGetModelTrims) {
    //         const currentModel = model;
    //         // add trims to versions
    //         currentModel.versions.forEach((version) => {
    //             const vers = dataGetModelTrims.versions.filter((ver) => {
    //                 return ver.id === version.id;
    //             });
    //             // eslint-disable-next-line no-param-reassign
    //             version.trims = vers[0].trims;
    //         });
    //         setCurrentVersion(currentModel.versions[0]);
    //         setModel(currentModel);
    //         props.actionSetGetModelTrimsToNull();
    //     }
    //     if (errorGetModelTrims) {
    //         setNotification({
    //             status: 'ok_and_dismiss',
    //             title: 'Il a eu une erreur',
    //             message: 'Merci de ressayer',
    //             errors: {},
    //         });
    //         props.actionSetGetModelTrimsToNull();
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [dataGetModelTrims, errorGetModelTrims]);

    const handleVersionSelect = (event) => {
        const newVersion = model.versions.filter((vs) => {
            return vs.id === event.target.id;
        });
        setCurrentVersion(newVersion[0]);
        setSelectedVersionIndex(parseInt(event.target.dataset.versionindex, 10));
    };
    const handleNotificationDismiss = () => {
        setNotification({
            status: '',
            title: '',
            message: '',
            errors: {},
        });
    };

    return (
        <>
            <NotifierDialog
                notification={notification}
                handleNotificationDismiss={handleNotificationDismiss}
            />
            <div className={styles.root}>
                {model && (
                    <>
                        <Card className={styles.cardRoot}>
                            <CardContent className={styles.cardContent}>
                                <div>
                                    <Link
                                        href={`/modeles-voiture/${model.brand.brand.replace(
                                            / /g,
                                            '-',
                                        )}/${model.model.replace(/ /g, '-')}`}
                                    >
                                        <Image
                                            src={`${process.env.NEXT_PUBLIC_API_HOST}/images/models/${model.images[0].filename}`}
                                            alt={model.brand.brand}
                                            width="300"
                                            height="200"
                                            priority
                                            layout="fixed"
                                        />
                                    </Link>
                                </div>
                                <div>
                                    <Collapse in={alertOpen}>
                                        <Alert
                                            style={{
                                                maxWidth: 500,
                                                margin: '0 auto',
                                                textAlign: 'left',
                                            }}
                                            variant="filled"
                                            severity="info"
                                            action={
                                                <IconButton
                                                    aria-label="close"
                                                    color="inherit"
                                                    size="small"
                                                    onClick={() => setAlertOpen(false)}
                                                >
                                                    <Close fontSize="inherit" />
                                                </IconButton>
                                            }
                                        >
                                            <>
                                                <p>Cliquez sur la version souhaitée</p>
                                                <p>
                                                    {`Résultat affiché (à la vitesse de l'éclair) sur
                                            le tableau en bas`}
                                                </p>
                                            </>
                                        </Alert>
                                    </Collapse>
                                </div>
                                <Box className={styles.versions}>
                                    {model?.versions.map((version, index) => (
                                        <Box key={version.id}>
                                            <Button
                                                data-versionindex={index}
                                                id={version.id}
                                                className={styles.range}
                                                variant="contained"
                                                disabled={!model}
                                                color={
                                                    selectedVersionIndex === index
                                                        ? 'secondary'
                                                        : 'primary'
                                                }
                                                onClick={handleVersionSelect}
                                            >
                                                {version.version}
                                            </Button>
                                        </Box>
                                    ))}
                                </Box>
                            </CardContent>
                            <CardActions>
                                {currentVersion && (
                                    <>
                                        <Chip
                                            size="small"
                                            label={`Prix: ${numberFrance(
                                                currentVersion.prices.edges[0].node.price,
                                            )} DH`}
                                            color="primary"
                                            avatar={
                                                <Avatar>
                                                    <MonetizationOn />
                                                </Avatar>
                                            }
                                        />
                                        {currentVersion.prices.edges[0].node.promo && (
                                            <Chip
                                                className={styles.isPromo}
                                                size="small"
                                                avatar={
                                                    <Avatar>
                                                        <MonetizationOn />
                                                    </Avatar>
                                                }
                                                label={`Promo: ${numberFrance(
                                                    currentVersion.prices.edges[0].node
                                                        .promo,
                                                )}  DH`}
                                                color="secondary"
                                            />
                                        )}
                                    </>
                                )}
                                <Card className={styles.cardRoot}>
                                    <CardHeader
                                        title={<h2>Caractéristiques techniques</h2>}
                                    />
                                    <CardContent className={styles.cardContent}>
                                        {currentVersion && (
                                            <ModelSpecs versions={[currentVersion]} />
                                        )}
                                    </CardContent>
                                </Card>
                                {currentVersion && (
                                    <SpecsSoeezautoTrims
                                        currentVersionId={currentVersion.id}
                                        model={model}
                                    />
                                )}
                            </CardActions>
                        </Card>
                    </>
                )}
            </div>
        </>
    );
};

FicheTechnique.propTypes = {
    model: PropTypes.object.isRequired,
};

export default React.memo(FicheTechnique);
